/**
 * tdesign v1.1.1
 * (c) 2023 tdesign
 * @license MIT
 */

import { MenuBlockType } from './type.js';

var checkIsSubMenu = function checkIsSubMenu(child) {
  if (!child) return false;
  var displayName = child.type.displayName;
  return displayName === MenuBlockType.SubMenu;
};
var checkIsMenuItem = function checkIsMenuItem(child) {
  if (!child) return false;
  var displayName = child.type.displayName;
  return displayName === MenuBlockType.MenuItem;
};
var checkIsMenuGroup = function checkIsMenuGroup(child) {
  if (!child) return false;
  var displayName = child.type.displayName;
  return displayName === MenuBlockType.MenuGroup;
};

export { checkIsMenuGroup, checkIsMenuItem, checkIsSubMenu };
//# sourceMappingURL=checkMenuType.js.map
